import React from 'react';
export const AnnouncementBar: React.FC = () => {
  const text = '⚠️ OFERTA ÚNICA PARA ARGENTINA: ÚLTIMAS HORAS CON 50% DE DESCUENTO — ACCESO INMEDIATO ⚠️';
  return <div className="bg-terracotta text-white py-2 overflow-hidden relative w-full" data-id="element-16">
      <div className="marquee-container w-full" data-id="element-17">
        <div className="animate-marquee marquee-content" data-id="element-18">
          <span className="mx-4 font-sans font-medium text-sm tracking-wide" data-id="element-19">
            {text}
          </span>
          <span className="mx-4 font-sans font-medium text-sm tracking-wide" data-id="element-20">
            {text}
          </span>
          <span className="mx-4 font-sans font-medium text-sm tracking-wide" data-id="element-21">
            {text}
          </span>
          <span className="mx-4 font-sans font-medium text-sm tracking-wide" data-id="element-22">
            {text}
          </span>
        </div>
      </div>
    </div>;
};